import { useEffect } from "react";

export const toggleSupportChat = (shouldDisplay: boolean) => {
  const widget = document.getElementById("amazon-connect-chat-widget");
  if (widget) {
    widget.style.display = shouldDisplay ? "block" : "none";
  }
};

export function useHideSupportChat() {
  useEffect(() => {
    toggleSupportChat(false);
    return () => {
      toggleSupportChat(true);
    };
  }, []);
}
